<div *ngIf="isVisible" @fullscreenVisibilityTrigger [ngClass]="loaderType === loaderEnum.MODAL ? 'modal-loader' : 'fullscreen-loader'">
  <div *ngIf="loaderType === loaderEnum.DEFAULT" class="fullscreen-loader-wrapper">
    <h3>{{ 'GENERAL.LOADING_TEXT' | translate }}</h3>
    <p class="text-muted">{{ 'GENERAL.LOADING_TEXT_ADDITIONAL' | translate }}</p>
    <div class="progress">
      <div
        class="progress-bar progress-bar-striped progress-bar-animated"
        role="progressbar"
        aria-valuenow="75"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 100%"
      ></div>
    </div>
  </div>

  <div *ngIf="loaderType === loaderEnum.MODAL" class="modal-loader-wrapper">
    <div class="modal-content">
      <h4>{{ contentfulBody ? contentfulBody : (contentfulMessageKey | translate) }}</h4>
      <div class="progress">
        <div class="progress-bar" role="progressbar"></div>
      </div>
    </div>
  </div>
</div>
